import { render, staticRenderFns } from "./RoutesList.vue?vue&type=template&id=3fc78f00&scoped=true"
import script from "./RoutesList.vue?vue&type=script&lang=js"
export * from "./RoutesList.vue?vue&type=script&lang=js"
import style0 from "./RoutesList.vue?vue&type=style&index=0&id=3fc78f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc78f00",
  null
  
)

export default component.exports